import {buyflowStore} from '@/app/signup/routing/buyflowStore';
import {SignupAnalyticsService} from '@/lib/analytics';
import {GtmAnalyticsWrapper} from '@gfiber/typesmith';

declare const dataLayer: Array<any>;

export const useAnalytics = () => getAnalytics();

// Actual singleton
let analytics: SignupAnalyticsService;
export const getAnalytics = () => {
  if (!analytics) {
    // TODO: to make sure this got called after dataLayer get initilized.
    const analyticsWrapper = new GtmAnalyticsWrapper(
      typeof dataLayer !== 'undefined' ? dataLayer : [],
    );

    analytics = new SignupAnalyticsService(
      analyticsWrapper,
      buyflowStore.state?.buyflowType, // maybe set after first buyflow response
    );
  }

  return analytics;
};
